<div wnlGroup #wnlGroup="wnlGroup">
  <div class="wnl-header">
    @if (patient().isPediatric()) {
      <p>
        WNL: Independent with ADL, no assistive devices, strong gait, not scored as fall risk on fall
        scale. Moves all extremities. Full range of motion. Strength appropriate for age.
      </p>
    } @else {
      <p>
        WNL: Independent with ADL, no assistive devices, strong gait, not scored as fall risk on fall
        scale. Moves all extremities. Full range of motion.
      </p>
    }
    <mat-checkbox [checked]="wnlGroup.allWnl" [indeterminate]="wnlGroup.someWnl"
      (change)="wnlGroup.setAllWnl($event.checked)"
      [ngClass]="{'wnl-checked': wnlGroup.allWnl && !wnlGroup.someWnl, 'wnl-indeterminate': wnlGroup.someWnl}">
      All Within Normal Limits
    </mat-checkbox>
  </div>

  <div [formGroup]="formGroup()" class="form-container">
  <assessment-row title="Mobility/Transfers">
    <emr-input type="select" [control]="formGroup().controls.mobilityAndTransfers"
      [options]="mobilityAndTransfersOptions" [wnlControl]="'mobilityAndTransfers'" [wnlDefault]="'No assists'" />
  </assessment-row>

  <assessment-row title="Assistive Devices">
    <emr-checkbox-group [control]="formGroup().controls.assistiveDevices" [options]="deviceOptions"
      [wnlControl]="'assistiveDevices'" [wnlDefault]="[]" />
  </assessment-row>

  @if (!patient().isPediatric()) {
    <div [wnlControl]="'adultFallRisk'" [wnlFormControl]="formGroup().controls.fallScore" [wnlIsWnl]="adultFallRiskIsWnl"
      [wnlApplyStrategy]="'keep'" [wnlClearStrategy]="'keep'"></div>
    <h2>Fall Risk</h2>
    <div class="fall-risk">
      <assessment-row title="Age" subtitle="(single-select)">
        <emr-input type="select" width="60%" [control]="formGroup().controls.fallRiskAge" [options]="ageOptions" />
      </assessment-row>

      <assessment-row title="Fall History" subtitle="(single-select)">
        <emr-checkbox [control]="formGroup().controls.fallHistory" [label]="fallHistoryOption" />
      </assessment-row>

      <assessment-row title="Elimination, Bowel and Urine" subtitle="(single-select)">
        <emr-input type="select" width="60%" [control]="formGroup().controls.fallRiskEbu" [options]="ebuOptions" />
      </assessment-row>

      <assessment-row title="Medications" subtitle="(single-select)" description="Includes PCA/opiates, anticonvulsants,
        anti-hypertensives, diuretics, hypnotics, laxatives, sedatives, and psychotropics">
        <emr-input type="select" width="60%" [control]="formGroup().controls.fallRiskMedications"
          [options]="medicationsOptions" />
      </assessment-row>

      <assessment-row title="Patient Care Equipment" subtitle="(single-select)" description="Any equipment that
        tethers patient (e.g. IV infusion, chest tube, indwelling catheter, SCDs, etc.)">
        <emr-input type="select" width="60%" [control]="formGroup().controls.fallRiskPce" [options]="pceOptions" />
      </assessment-row>

      <assessment-row title="Mobility" subtitle="(multi-select; choose all that apply)">
        <emr-checkbox-group [control]="formGroup().controls.fallRiskMobility" [options]="mobilityFallRiskOptions" />
      </assessment-row>

      <assessment-row title="Cognition" subtitle="(multi-select; choose all that apply)">
        <emr-checkbox-group [control]="formGroup().controls.fallRiskCognition" [options]="cognitionOptions" />
      </assessment-row>

      <assessment-row title="Total Fall Risk Score" description="Sum of all points per category">
        <h3 class="fr-score">{{ computeFallRiskScore() }}</h3>
      </assessment-row>

      <assessment-row title="Fall Risk">
        <h3 class="fr-label">{{ computeFallRiskCategory() }}</h3>
      </assessment-row>
    </div>
  }
  @if (patient().isPediatric()) {
    <div [wnlControl]="'pediatricFallRisk'" [wnlFormControl]="formGroup().controls.HDtotalScore"
      [wnlIsWnl]="pediatricFallRiskIsWnl" [wnlApplyStrategy]="'keep'" [wnlClearStrategy]="'keep'"></div>
    <h2>Humpty Dumpty Fall Scale</h2>
    <div class="fall-risk">
      <assessment-row title="Age" id="HDage">
        <emr-input type="select" width="60%" [control]="formGroup().controls.HDage" [options]="HDageOptions" />
      </assessment-row>
      <assessment-row title="Gender" id="HDgender">
        <emr-input type="select" width="60%" [control]="formGroup().controls.HDgender" [options]="HDgenderOptions" />
      </assessment-row>
      <assessment-row title="Diagnosis" id="HDdiagnosis">
        <emr-input type="select" width="60%" [control]="formGroup().controls.HDdiagnosis" [options]="HDdiagnosisOptions" />
      </assessment-row>
      <assessment-row title="Cognitive Impairment" id="HDcognitiveImpairment">
        <emr-input type="select" width="60%" [control]="formGroup().controls.HDcognitiveImpairment"
          [options]="HDcognitiveImpairmentOptions" />
      </assessment-row>
      <assessment-row title="Environmental Factors" id="HDenvironmentalFactors">
        <emr-input type="select" width="60%" [control]="formGroup().controls.HDenvironmentalFactors"
          [options]="HDenvironmentalFactorsOptions" />
      </assessment-row>
      <assessment-row title="Response to Surgery" id="HDresponseToSurgery">
        <emr-input type="select" width="60%" [control]="formGroup().controls.HDresponseToSurgery"
          [options]="HDresponseToSurgeryOptions" />
      </assessment-row>
      <assessment-row title="Medication Usage" id="HDmedicationUsage">
        <emr-input type="select" width="60%" [control]="formGroup().controls.HDmedicationUsage"
          [options]="HDmedicationUsageOptions" />
      </assessment-row>
      <assessment-row title="Total Humpty Dumpty Score">
        <h3 class="fr-score">{{ computeHDSScore() }}</h3>
      </assessment-row>
      <assessment-row title="Fall Risk">
        <h3 class="fr-label">{{ computeHDSCategory() }}</h3>
      </assessment-row>
    </div>
  }

  <assessment-row title="Limited Range of Motion">
    <emr-input type="text" [control]="formGroup().controls.limitedRangeOfMotion" [wnlControl]="'limitedRangeOfMotion'"
      [wnlDefault]="''" />
  </assessment-row>

  <assessment-row title="Deformities Present">
    <emr-input type="text" [control]="formGroup().controls.deformitiesPresent" [wnlControl]="'deformitiesPresent'"
      [wnlDefault]="''" />
  </assessment-row>

  <assessment-row title="Other Findings">
    <emr-input type="text" [control]="formGroup().controls.otherFindings" [wnlControl]="'otherFindings'"
      [wnlDefault]="''" />
  </assessment-row>
</div>
</div>